import { CancelOrder, CreateInStoreOrder, CreateOrder, CreateOrderResponse, GetAllOrders, Order, SimplifiedOrder } from "../../Models/Order";
import { ShippingTrackingResponse } from "../../Models/ShippingTracking";
import { PagedResult } from "../../Models/PagedResult";
import { OrderNfeEmissionResponse } from "../../Models/Nfe";
import { UpdateShippingDetails } from "../../Models/Order";
import api from "../axios";

export const orderService = {
  get: async (id: string): Promise<Order> => {
    const response = await api.get(`/order/${id}`);
    return response.data;
  },

  getByCustomer: async (page: number, pageSize: number): Promise<PagedResult<SimplifiedOrder>> => {
    const response = await api.get('/order/by-customer', {
      params: { page, pageSize }
    });
    return response.data;
  },

  getCount: async (): Promise<number> => {
    const response = await api.get('/order/count');
    return response.data;
  },

  getAll: async (data: GetAllOrders): Promise<PagedResult<SimplifiedOrder>> => {
    const queryParams = new URLSearchParams();

    queryParams.append("page", data.page.toString());
    queryParams.append("pageSize", data.pageSize.toString());

    if (data.status !== undefined && data.status !== null) {
      queryParams.append("status", data.status.toString());
    }

    if (data.customerId) {
      queryParams.append("customerId", data.customerId);
    }

    if (data.orderSource !== undefined && data.orderSource !== null) {
      queryParams.append("orderSource", data.orderSource.toString());
    }

    const response = await api.get(`/order?${queryParams.toString()}`);
    return response.data;
  },

  create: async (data: CreateOrder): Promise<CreateOrderResponse | null> => {
    const response = await api.post('/order', data);
    return response.data;
  },

  createInStore: async (data: CreateInStoreOrder): Promise<CreateOrderResponse | null> => {
    const response = await api.post('/order/in-store', data);
    return response.data;
  },

  updateAvailability: async (orderId: string, maxMadeToOrderLeadTimeDays: number | null): Promise<boolean> => {
    const response = await api.patch(`/order/${orderId}/availability`, { maxMadeToOrderLeadTimeDays });
    return response.data;
  },

  updateShippingDetails: async (data: UpdateShippingDetails) => {
    const response = await api.patch("/order/shipping-details", data);
    return response.data;
  },

  getShippingTracking: async (orderId: string): Promise<ShippingTrackingResponse> => {
    const response = await api.get(`/order/${orderId}/tracking`);
    return response.data;
  },

  cancel: async (data: CancelOrder): Promise<boolean> => {
    const response = await api.patch('/order/cancel', data);
    return response.data;
  },

  emitNfe: async (orderId: string): Promise<OrderNfeEmissionResponse> => {
    const response = await api.post(`/order/${orderId}/emit-nfe`);
    return response.data;
  },

  cancelNfe: async (orderId: string, justification?: string): Promise<OrderNfeEmissionResponse> => {
    const response = await api.post(`/order/${orderId}/cancel-nfe`, { justification });
    return response.data;
  },

  emitPrePosting: async (orderId: string, data: { packagingType: number; weightGrams: number; lengthCm: number; widthCm: number; heightCm: number }): Promise<boolean> => {
    const response = await api.post(`/order/${orderId}/pre-posting/emit`, data);
    return response.data;
  },

  requestPrePostingLabel: async (orderId: string): Promise<boolean> => {
    const response = await api.post(`/order/${orderId}/pre-posting/label`);
    return response.data;
  },

  downloadPrePostingLabel: async (orderId: string): Promise<Blob> => {
    const response = await api.get(`/order/${orderId}/pre-posting/label`, { responseType: "blob" });
    return response.data;
  }
};
